import React, { useCallback, useEffect, useState } from 'react';
import '../../../css/print.css';
import { useParams, useSearchParams } from 'react-router-dom';
import { usePrescriptionToPrint } from './hooks/usePrescriptionToPrint';

const styles = {
  content: {
    position: 'absolute',
    top: '55mm',
    left: '35mm',
    right: '12mm',
    bottom: '55mm',
    fontFamily: 'Arial, sans-serif',
    fontSize: '11pt',
    color: '#222',
  },
  medicamento: {
    marginBottom: '6mm',
  },
  medicamentoNome: {
    fontWeight: 'bold',
    margin: 0,
    fontSize: '11pt',
  },
  medicamentoPosologia: {
    margin: '1mm 0 0 0',
    fontSize: '10pt',
    color: '#444',
  },
  divider: {
    borderTop: '1px dashed #bbb',
    margin: '4mm 0',
  },
};

export default function PrescriptionToPrintWithTemplate() {
  const { patientId, prescriptionId } = useParams();
  const [searchParams] = useSearchParams();
  const templateUrl = searchParams.get('templateUrl');
  const { fetchPrescriptionToPrint } = usePrescriptionToPrint();
  const [prescriptionToPrint, setPrescriptionToPrint] = useState(null);

  const pageStyle = {
    width: '210mm',
    minHeight: '297mm',
    position: 'relative',
    backgroundImage: templateUrl ? `url(${templateUrl})` : '',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    WebkitPrintColorAdjust: 'exact',
    printColorAdjust: 'exact',
    margin: '0 auto',
  };

  const getPrescriptionToPrint = useCallback(() => {
    fetchPrescriptionToPrint(patientId, prescriptionId)
      .then((returnFromApi) => {
        setPrescriptionToPrint(returnFromApi.data);
      })
      .catch((returnFromApi) => {
        console.error('ops! ocorreu um erro' + returnFromApi);
      });
  }, [patientId, prescriptionId, fetchPrescriptionToPrint]);

  useEffect(() => {
    getPrescriptionToPrint();

    const handleAfterPrint = () => {
      window.close();
    };
    document.body.classList.add('printing-active');
    window.addEventListener('afterprint', handleAfterPrint);

    const timer = setTimeout(() => {
      window.print();
    }, 500);

    return () => clearTimeout(timer);
  }, [getPrescriptionToPrint]);

  return (
    <div style={pageStyle}>
      <div style={styles.content}>
        <div className="mt-5">
          <p>Paciente: {prescriptionToPrint?.nomeDoPaciente}</p>
        </div>

        <div className="mt-5">
          <p>Uso Interno</p>
        </div>

        {prescriptionToPrint?.medicamentos.map((medicamento, index) => (
          <div key={index} style={styles.medicamento}>
            <p style={styles.medicamentoNome}>
              {medicamento.nome} - {medicamento.descricaoQuantidade}
            </p>
            <p style={styles.medicamentoPosologia}>{medicamento.posologia}</p>
            <div style={styles.divider} />
          </div>
        ))}

        <div className="text-center mt-5">
          <p>Data: {prescriptionToPrint?.data}</p>
          <p>______________________________</p>
          <p>Assinatura do Profissional</p>
        </div>
      </div>
    </div>
  );
}
